// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__fuCM1","footer":"ModalFilter_footer__2Qvrj"};